import { DocumentRequestCard } from '@/components/document-requests/document-request-card'
import { useDocumentRequests } from '@/hooks/use-document-requests'

/** Staff see every plot's requests (server-scoped); a member sees only their own. */
export function DocumentRequestsTab() {
  const { data, isLoading } = useDocumentRequests()
  const requests = data?.data ?? []

  if (isLoading) return <p className="font-sans text-sm text-muted-foreground">Loading…</p>
  if (requests.length === 0) {
    return (
      <p className="rounded border border-border-2 px-4 py-6 text-center font-sans text-sm text-muted-foreground">
        No document requests yet.
      </p>
    )
  }

  return (
    <div className="space-y-4">
      {requests.map((request) => (
        <DocumentRequestCard key={request.id} request={request} />
      ))}
    </div>
  )
}
